import { addImageParams } from '@/utils/urls';

const BANNER_IMAGE_HEIGHT = 240;
const IMAGE_QUALITY = 100;
const BANNER_IMAGE_BASE_URL = 'https://p1.liveauctioneers.com/dist/images/htw_homepage_banner_asset.png';

export const BANNER_GRADIENT_STYLE = {
    background: 'linear-gradient(88deg, rgba(0, 155, 204, 0.30) 0%, rgba(236, 250, 255, 0.30) 100.84%), #C6F1FF',
} as const;

export const BANNER_IMAGE_URL = addImageParams({
    height: BANNER_IMAGE_HEIGHT,
    quality: IMAGE_QUALITY,
    sharpen: true,
    url: BANNER_IMAGE_BASE_URL,
});
